/*
 * RILDY — Carrinho
 *
 * - Barra de frete grátis + brindes (markup em snippets/rildy-cart-progress.liquid)
 * - Brindes automáticos: cada um entra no carrinho ao atingir o seu valor
 *   e sai se o total cair (configuração em snippets/rildy-cart-config.liquid)
 * - Contador do cabeçalho e classe de carrinho vazio
 * - Faixa "Leve também" e atalho "Continuar comprando"
 *
 * O carrinho é relido a cada mudança, reaproveitando os eventos que o
 * tema já dispara.
 */
(function () {
  'use strict';

  var CART_EVENTS = ['theme:cart:added', 'theme:cart:loaded', 'theme:cart:open', 'theme:cart:update', 'theme:cart:refresh'];

  /*
   * O brinde só é sincronizado quando o tema não está mexendo no
   * carrinho: "added" vem no fim do redesenho, "loaded" quando o drawer
   * nasce e "open" a cada abertura. Em "update" o tema ainda está
   * alterando linhas pelo índice, e mexer no carrinho ao mesmo tempo
   * trocaria a linha que ele altera.
   */
  var GIFT_SYNC_EVENTS = ['theme:cart:added', 'theme:cart:loaded', 'theme:cart:open'];
  var GIFT_PROPERTY = '_rildy_brinde';

  /*
   * O total do carrinho é o único lugar em que o tema usa
   * moneyWithCurrencyFormat, e ele imprime "R$ 159,00 BRL". Como a loja
   * está com o código da moeda desligado nas configurações, apontamos
   * esse formato para o normal — o Liquid já faz o mesmo na primeira
   * renderização, isto cobre as atualizações via JS.
   */
  if (window.theme && window.theme.settings && !window.theme.settings.currency_code_enable) {
    window.theme.moneyWithCurrencyFormat = window.theme.moneyFormat;
  }

  function readConfig() {
    var el = document.getElementById('RildyCartConfig');
    if (!el) return {};

    try {
      return JSON.parse(el.textContent) || {};
    } catch (error) {
      return {};
    }
  }

  var config = readConfig();
  var giftConfig = config.gift || {};
  var giftItems = (giftConfig.items || []).filter(function (item) {
    return item && item.variantId;
  });
  var giftVariantIds = giftItems.map(function (item) {
    return item.variantId;
  });
  // Brindes automáticos ligados e com produto escolhido
  var gift = giftConfig.enabled && giftItems.length ? giftConfig : null;

  function currencyRate() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
      return parseFloat(window.Shopify.currency.rate) || 1;
    }
    return 1;
  }

  // Valores dos marcos vêm em centavos da moeda da loja
  function toCents(cents) {
    var amount = parseFloat(cents);
    if (!amount || amount <= 0) return 0;
    return amount * currencyRate();
  }

  function formatMoney(cents) {
    var value = Math.max(0, Math.round(cents));

    if (window.theme && typeof window.theme.formatMoney === 'function') {
      var formatted = window.theme.formatMoney(value, window.theme.moneyFormat);

      // O tema esconde os centavos zerados nas mensagens de frete; seguimos igual.
      if (formatted.endsWith('.00') || formatted.endsWith(',00')) {
        formatted = formatted.slice(0, -3);
      }

      return formatted;
    }

    return (value / 100).toFixed(2);
  }

  /*
   * Linha de brinde: a que este arquivo marcou ao adicionar, ou um dos
   * produtos de brinde a R$ 0,00 (mesma regra do Liquid em
   * cart-line-items e rildy-cart-progress).
   */
  function isGiftLine(item) {
    if (item.properties && item.properties[GIFT_PROPERTY]) return true;
    return giftVariantIds.indexOf(item.variant_id) !== -1 && item.original_price === 0;
  }

  // Valor que conta para os marcos: o carrinho sem os brindes
  function progressTotal(cart) {
    return cart.items.reduce(function (total, item) {
      return isGiftLine(item) ? total - item.final_line_price : total;
    }, cart.total_price);
  }

  /*
   * Régua de progresso
   */
  var lastCart = null;

  class RildyCartProgress extends HTMLElement {
    connectedCallback() {
      this.messageEl = this.querySelector('[data-rildy-message]');
      this.fillEl = this.querySelector('[data-rildy-fill]');
      this.steps = Array.from(this.querySelectorAll('[data-rildy-step]')).map(function (el) {
        return {
          el: el,
          limit: toCents(el.dataset.cents),
          label: (el.dataset.label || '').trim(),
          message: el.dataset.message || '',
        };
      });

      // O drawer nasce do <template> com o carrinho do carregamento da
      // página, que pode ter mudado desde então.
      if (lastCart) this.render(progressTotal(lastCart));
      loadCart();
    }

    render(total) {
      if (!this.steps || !this.steps.length) return;

      var filled = 0;
      var previous = 0;
      var next = null;

      // Os marcos ficam em intervalos iguais: cada trecho enche de 0 a 1
      this.steps.forEach(function (step) {
        var reached = total >= step.limit;

        if (reached) {
          filled += 1;
        } else if (total > previous) {
          filled += (total - previous) / (step.limit - previous);
        }

        if (!reached && !next) next = step;

        step.el.classList.toggle('is-reached', reached);
        previous = step.limit;
      });

      this.steps.forEach(function (step) {
        step.el.classList.toggle('is-next', step === next);
      });

      if (this.fillEl) {
        this.fillEl.style.setProperty('--rildy-progress', (filled / this.steps.length) * 100 + '%');
      }

      if (!this.messageEl) return;

      var message = next ? next.message : this.dataset.msgComplete || '';
      var remaining = next ? next.limit - total : 0;

      this.messageEl.innerHTML = this.destacar(message).replace(/\|\|amount\|\|/g, '<strong>' + formatMoney(remaining) + '</strong>');
    }

    // Os nomes dos marcos ("frete grátis", "brinde") ficam em negrito na frase
    destacar(message) {
      var nomes = this.steps
        .map(function (step) {
          return step.label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        })
        .filter(Boolean);

      if (!nomes.length) return message;

      return message.replace(new RegExp('(' + nomes.join('|') + ')', 'giu'), '<span class="rildy-progress__destaque">$1</span>');
    }
  }

  if (!customElements.get('rildy-cart-progress')) {
    customElements.define('rildy-cart-progress', RildyCartProgress);
  }

  /*
   * Contador ao lado do "Carrinho" no cabeçalho.
   *
   * O Liquid já imprime o valor certo no carregamento; isto cobre as
   * mudanças feitas sem recarregar a página. O tema não expõe a
   * quantidade num atributo, só a classe cart__toggle--has-items, por
   * isso lemos o carrinho.
   */
  function escreverContador(quantidade) {
    document.querySelectorAll('[data-rildy-cart-count]').forEach(function (el) {
      el.textContent = quantidade > 0 ? '(' + quantidade + ')' : '';
    });
  }

  /*
   * Carrinho vazio: a classe no drawer esconde a régua de frete/brinde e
   * a faixa "Leve também". O Liquid já marca no carregamento; aqui
   * acompanhamos as mudanças feitas sem recarregar.
   */
  function marcarVazio(quantidade) {
    var drawer = document.querySelector('.cart-drawer');
    if (drawer) drawer.classList.toggle('rildy-cart-vazio', quantidade === 0);
  }

  function aplicarCarrinho(cart) {
    var total = progressTotal(cart);

    document.querySelectorAll('rildy-cart-progress').forEach(function (el) {
      if (typeof el.render === 'function') el.render(total);
    });

    escreverContador(cart.item_count);
    marcarVazio(cart.item_count);
  }

  /*
   * Brindes automáticos
   *
   * Os brindes acumulam: cada valor atingido deixa uma unidade do seu
   * brinde no carrinho, e abaixo dele a unidade sai. Linhas de brinde de
   * um produto que saiu da configuração também saem.
   */
  var sincronizando = false;
  var pendente = false;
  var falhas = {};
  var aguardandoEco = false;
  var ecosSeguidos = 0;

  // Os produtos do carrinho, sem o brinde: muda sempre que o cliente mexe
  function chaveDoCarrinho(cart) {
    return cart.items
      .filter(function (item) {
        return !isGiftLine(item);
      })
      .map(function (item) {
        return item.key + ':' + item.quantity;
      })
      .sort()
      .join('|');
  }

  function planoDoBrinde(cart) {
    var total = progressTotal(cart);
    var chave = chaveDoCarrinho(cart);
    var desejado = {};
    var mantidos = {};
    var updates = {};
    var adicionar = [];

    // Quantas unidades de cada produto de brinde o carrinho deve ter
    if (gift) {
      giftItems.forEach(function (item) {
        if (total >= toCents(item.cents)) {
          var id = String(item.variantId);
          desejado[id] = (desejado[id] || 0) + 1;
        }
      });
    }

    cart.items.forEach(function (item) {
      var id = String(item.variant_id);
      var marcado = item.properties && item.properties[GIFT_PROPERTY];
      var gratisDaConfig = Boolean(gift) && giftVariantIds.indexOf(item.variant_id) !== -1 && item.original_price === 0;

      // Com o automático desligado, só mexemos no que nós mesmos pusemos
      if (!marcado && !gratisDaConfig) return;

      if (desejado[id] && !mantidos[id]) {
        mantidos[id] = true;
        if (item.quantity !== desejado[id]) updates[item.key] = desejado[id];
      } else {
        updates[item.key] = 0;
      }
    });

    Object.keys(desejado).forEach(function (id) {
      if (mantidos[id] || falhas[chave + '#' + id]) return;

      var disponivel = giftItems.some(function (item) {
        return String(item.variantId) === id && item.available;
      });

      if (disponivel) adicionar.push({ id: Number(id), quantity: desejado[id] });
    });

    return { updates: updates, adicionar: adicionar };
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (response) {
      if (!response.ok) throw new Error(response.status);
      return response.json();
    });
  }

  function sincronizarBrinde(cart, eco) {
    // Chegou outra mudança no meio desta: confere de novo no fim
    if (sincronizando) {
      pendente = true;
      return;
    }

    var plano = planoDoBrinde(cart);
    var temUpdates = Object.keys(plano.updates).length > 0;
    var chave = chaveDoCarrinho(cart);

    if (!temUpdates && !plano.adicionar.length) {
      ecosSeguidos = 0;
      return;
    }

    /*
     * Trava contra vaivém. Depois que mexemos no carrinho, o tema o
     * redesenha e nos chama de novo: é o "eco". Se no eco ainda houver o
     * que mudar sem o cliente ter feito nada, o carrinho está oscilando
     * (um desconto no pedido inteiro perto do valor mínimo, por exemplo).
     * Paramos depois de duas tentativas; qualquer ação do cliente libera.
     */
    if (eco) {
      ecosSeguidos += 1;
      if (ecosSeguidos > 2) return;
    } else {
      ecosSeguidos = 0;
    }

    sincronizando = true;

    // Mesmo estado de carregamento do tema: trava quantidade e "Remover"
    // até o drawer ser redesenhado com o brinde.
    var drawer = document.querySelector('.cart-drawer');
    if (drawer) drawer.classList.add('is-loading');

    var routes = window.theme.routes;
    var pedido = Promise.resolve();
    var mudou = false;

    if (temUpdates) {
      pedido = pedido.then(function () {
        return postJson(routes.cart_update_url + '.js', { updates: plano.updates }).then(function () {
          mudou = true;
        });
      });
    }

    // Um brinde por vez: se um estiver sem estoque, os outros entram mesmo assim
    plano.adicionar.forEach(function (brinde) {
      pedido = pedido.then(function () {
        var properties = {};
        properties[GIFT_PROPERTY] = 'Sim';

        return postJson(routes.cart_add_url + '.js', {
          items: [{ id: brinde.id, quantity: brinde.quantity, properties: properties }],
        })
          .then(function () {
            mudou = true;
          })
          .catch(function () {
            // Sem estoque ou indisponível no canal: não insiste até o carrinho mudar
            falhas[chave + '#' + brinde.id] = true;
          });
      });
    });

    pedido
      .catch(function () {})
      .then(function () {
        sincronizando = false;

        if (!mudou) {
          if (drawer) drawer.classList.remove('is-loading');

          if (pendente) {
            pendente = false;
            loadCart(true);
          }
          return;
        }

        // O redesenho abaixo dispara outra conferência
        pendente = false;

        // Na página /cart não há drawer para redesenhar
        if (config.template === 'cart') {
          if (podeRecarregar()) window.location.reload();
          return;
        }

        // O tema relê o carrinho, redesenha as linhas e tira o is-loading
        aguardandoEco = true;
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      });
  }

  /*
   * Na página /cart a trava de vaivém some a cada recarga, então ela
   * fica guardada na sessão: no máximo 3 recargas em 30 segundos.
   */
  function podeRecarregar() {
    var chave = 'rildyBrindeRecargas';

    try {
      var agora = Date.now();
      var recargas = JSON.parse(sessionStorage.getItem(chave) || '[]').filter(function (quando) {
        return agora - quando < 30000;
      });

      if (recargas.length >= 3) return false;

      recargas.push(agora);
      sessionStorage.setItem(chave, JSON.stringify(recargas));
      return true;
    } catch (error) {
      return false;
    }
  }

  /*
   * Leitura do carrinho
   *
   * Vários eventos chegam em sequência numa mesma atualização; a leitura
   * espera eles pararem.
   */
  var timerCarrinho;
  var sincronizarNaLeitura = false;
  // Só é eco se todos os eventos desta leitura forem eco
  var ecoNaLeitura = null;

  function loadCart(sincronizar, eco) {
    if (sincronizar) {
      sincronizarNaLeitura = true;
      ecoNaLeitura = ecoNaLeitura === null ? Boolean(eco) : ecoNaLeitura && Boolean(eco);
    }

    clearTimeout(timerCarrinho);
    timerCarrinho = setTimeout(function () {
      var sincronizarAgora = sincronizarNaLeitura;
      var ecoAgora = ecoNaLeitura === true;
      sincronizarNaLeitura = false;
      ecoNaLeitura = null;

      fetch(window.theme.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (cart) {
          if (!cart) return;

          lastCart = cart;
          aplicarCarrinho(cart);

          if (sincronizarAgora) sincronizarBrinde(cart, ecoAgora);
        })
        .catch(function () {});
    }, 120);
  }

  CART_EVENTS.forEach(function (nome) {
    document.addEventListener(nome, function () {
      // O primeiro "added" depois de mexermos no carrinho é o redesenho que pedimos
      var eco = nome === 'theme:cart:added' && aguardandoEco;
      if (eco) aguardandoEco = false;

      loadCart(GIFT_SYNC_EVENTS.indexOf(nome) !== -1, eco);
    });
  });

  // Na página /cart o carrinho não passa pelo drawer: confere o brinde ao abrir
  if (config.template === 'cart') {
    loadCart(true);
  }

  /*
   * Faixa "Leve também".
   *
   * O tema monta um carrossel Flickity que centraliza UM card por vez e
   * não tem como mostrar dois sem reconfigurar a instância. Aqui ele é
   * desmontado e no lugar fica uma faixa de rolagem nativa com
   * scroll-snap: dois cards visíveis, arrastável no toque e com as
   * setas abaixo. Também devolvemos o tabindex que o Flickity tira dos
   * cards que não estavam selecionados.
   */
  function desmontarCarrossel(slider) {
    if (!slider || !slider.classList.contains('flickity-enabled')) return;

    var Flickity = window.theme && window.theme.Flickity;
    var flkty = Flickity && Flickity.data(slider);
    if (!flkty) return;

    flkty.destroy();

    slider.querySelectorAll('[tabindex="-1"]').forEach(function (el) {
      el.removeAttribute('tabindex');
    });
  }

  function atualizarSetas(slider) {
    var pair = slider.closest('.rildy-pair');
    if (!pair) return;

    var nav = pair.querySelector('.rildy-pair__nav');
    if (!nav) return;

    // Sem transbordo não há o que navegar
    var temMais = slider.scrollWidth - slider.clientWidth > 4;
    nav.classList.toggle('is-hidden', !temMais);

    var prev = pair.querySelector('[data-rildy-pair-prev]');
    var next = pair.querySelector('[data-rildy-pair-next]');
    if (prev) prev.disabled = slider.scrollLeft <= 2;
    if (next) next.disabled = slider.scrollLeft >= slider.scrollWidth - slider.clientWidth - 2;
  }

  /*
   * Arrastar com o dedo dentro do drawer.
   *
   * Quando o carrinho abre, o tema tranca a rolagem da página com um
   * listener de touchmove no document que cancela o gesto. Como esta
   * faixa fica fora da área que o tema liberou, o arrasto morria ali.
   * Parar a propagação nos gestos horizontais devolve a rolagem nativa
   * sem mexer na trava do resto da página.
   */
  function habilitarArrasto(slider) {
    if (slider.dataset.rildyArrasto) return;
    slider.dataset.rildyArrasto = 'true';

    var x0 = 0;
    var y0 = 0;

    slider.addEventListener(
      'touchstart',
      function (event) {
        x0 = event.touches[0].clientX;
        y0 = event.touches[0].clientY;
      },
      { passive: true }
    );

    slider.addEventListener(
      'touchmove',
      function (event) {
        var toque = event.touches[0];
        if (Math.abs(toque.clientX - x0) > Math.abs(toque.clientY - y0)) {
          event.stopPropagation();
        }
      },
      { passive: true }
    );
  }

  function varrer() {
    document.querySelectorAll('.rildy-pair [data-pair-products]').forEach(function (slider) {
      desmontarCarrossel(slider);
      atualizarSetas(slider);
      habilitarArrasto(slider);

      if (!slider.dataset.rildyScrollBound) {
        slider.dataset.rildyScrollBound = 'true';
        slider.addEventListener('scroll', function () {
          atualizarSetas(slider);
        });
      }
    });
  }

  var agendado = false;
  function agendarVarredura() {
    if (agendado) return;
    agendado = true;
    requestAnimationFrame(function () {
      agendado = false;
      varrer();
    });
  }

  new MutationObserver(agendarVarredura).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.addEventListener('resize', agendarVarredura);
  agendarVarredura();

  /*
   * "Continuar comprando": o tema recolhe os botões que fecham o drawer
   * no carregamento da página, e este link nasce depois, quando o
   * template do drawer é clonado. Reaproveitamos o X do próprio drawer,
   * que já está ligado ao fechamento do tema.
   */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-rildy-continuar]');
    if (!link) return;

    event.preventDefault();

    var fechar = document.querySelector('.cart-drawer .cart-drawer__close');
    if (fechar) fechar.click();
  });

  document.addEventListener('click', function (event) {
    var prev = event.target.closest('[data-rildy-pair-prev]');
    var next = event.target.closest('[data-rildy-pair-next]');
    if (!prev && !next) return;

    event.preventDefault();

    var pair = (prev || next).closest('.rildy-pair');
    var slider = pair && pair.querySelector('[data-pair-products]');
    if (!slider) return;

    var card = slider.querySelector('.product-upsell__holder');
    var passo = card ? card.getBoundingClientRect().width + 10 : slider.clientWidth / 2;

    slider.scrollBy({ left: prev ? -passo : passo, behavior: 'smooth' });
  });
})();
